<template>
    <router-link class="item" :size="getSize" @click.prevent="click" :to="item.to">
        <i class="icon">
            {{ item.icon }}
        </i>
        <span class="text">
            {{ item.text }}
        </span>
    </router-link>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'NavItem',

    computed: {
        getSize() {
            const somPrihlaseny = false;
            return somPrihlaseny ? this.item.size : '';
        },
    },

    props: {
        /**
         * Item prop ktorý niečo spôsobuje.
         * S default() funkciou aby fungoval v Styleguide, alebo by to mohlo byť v mock datach
         */
        item: {
            type: Object,
            default: () => {
                return { icon: 'add', text: 'item', size: 'xxl' };
            },
        },
    },

    methods: {
        click(event) {
            /**
             * Click funkcia s eventom
             */
            this.closeMenuPopup();

            if (typeof this.item.click == 'function') {
                if (this.item.click(this) === false) return;
            }
            if (this.item.link) return this.$router.push(this.item.link);
        },

        ...mapActions(['closeMenuPopup']),
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

.item[size='small'] {
    // padding: 0px 20px;
    height: 33px;
    color: @black;
    font-size: 12px;
    font-weight: 400;
    border-color: @grey_lt;
    margin-top: -1px;

    &:last-child {
        border-bottom-color: @grey_lt;
        .radiusMid-b;
        overflow: hidden;
    }

    .icon {
        margin-right: 4px;
        font-size: 15px;
    }
}

.item {
    position: relative;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: @dark;
    padding: 0px 10px;
    height: 50px;
    font-size: 17px;
    font-weight: 900;
    letter-spacing: 0.04em;
    transition: 0.3s;
    background: transparent;
    border-radius: 0px;
    border-style: solid;
    border-color: transparent transparent @grey_lt transparent;
    border-width: 1px;

    @media (max-width: 760px) {
        height: 40px;
        font-size: 13px;
    }

    &:after {
        .gradientDarken;
        .fullFillBground;
        opacity: 0;
        transition: 0.3s;
    }

    &:first-child {
        .radiusMid-t;
        overflow: hidden;
    }

    &:last-child {
        border-bottom-color: transparent;
        .radiusMid-b;
        overflow: hidden;
    }

    &:hover {
        border-color: transparent @grey_lt @grey_lt @grey_lt;

        &:after {
            opacity: 0.5;
        }

        &:first-child {
            border-top-color: @grey_lt;
        }

        &:last-child {
            border-bottom-color: transparent;
        }
    }

    .icon {
        margin-right: 10px;
    }

    .text {
        text-transform: uppercase;
    }
}

.router-link-exact-active {
    &:after {
        // opacity: 0.2;
    }

    color: @primary;

    // &:first-child{
    // 	border-top-color: @grey_lt;
    // }

    // &:last-child{
    // 	border-bottom-color: @grey_lt;
    // }
}
</style>
